module.exports = __webpack_public_path__ + "static/media/fly0135.383b1e48.webp";